import {useStore} from '@/store/root-store';
import {CloseOutlined} from '@ant-design/icons';
import {Drawer} from 'antd';
import {observer} from 'mobx-react';
import styles from './style.module.scss';
import {CompetitorHeadingsDrawerContent} from './DrawerContent';
import {useState} from 'react';

interface Props {
  htmlToDraft: any;
}

export const CompetitorsHeadingsDrawer = observer(({htmlToDraft}: Props) => {
  const {contentOptimizer: {currentPage: {analytics, topRankingCompetitorActiveKw, isCompetitorsHeadingsDrawerOpen, closeCompetitorsHeadingsDrawer, setCopiedHeadings}}} = useStore('');

  const [compListCollapsed, setCompListCollapsed] = useState(false);
  const [activeKw, setActiveKw] = useState<string>('');
  const [showBulkAddContentBtn, setShowBulkAddContentBtn] = useState(true);
  const [checkedCount, setCheckedCount] = useState(0);
  const [checkedHeadingsWithTags, setCheckedHeadingsWithTags] = useState('');
  const [checkedIndexData, setCheckedIndexData] = useState([]);

  return (
    <Drawer
      visible={isCompetitorsHeadingsDrawerOpen}
      placement='right'
      mask={true}
      // afterVisibleChange={visibilityChangeHandler}
      width={compListCollapsed ? '800px' : '1030px'}
      onClose={() => {
        closeCompetitorsHeadingsDrawer();
        if (topRankingCompetitorActiveKw && analytics?.competitorsData?.length && analytics?.competitorsData.find(item => item.keyword == topRankingCompetitorActiveKw)) {
          setActiveKw(topRankingCompetitorActiveKw);
        } else if (analytics?.competitorsData && analytics?.competitorsData[0]) {
          setActiveKw(analytics?.competitorsData[0]?.keyword);
        } else {
          setActiveKw('');
        }
        setCheckedCount(0);
        setShowBulkAddContentBtn(true);
        setCheckedIndexData([]);
        setCopiedHeadings('');
      }}
      closeIcon={<CloseOutlined onClick={() => {
        setCheckedCount(0);
        setShowBulkAddContentBtn(true);
        setCheckedIndexData([]);
        setCopiedHeadings('');
      }} style={{display: isCompetitorsHeadingsDrawerOpen ? 'block' : 'none'}}/>}
      className={styles.competitorsHeadingsDrawerStyle}
      bodyStyle={{backgroundColor: '#F2F2F5', paddingLeft: '0', paddingRight: '0'}}
    >
      <div style={{paddingLeft: 30, fontSize: 24, fontWeight: 600}}>Headings Outline</div>
      <CompetitorHeadingsDrawerContent
        activeKw={activeKw}
        setActiveKw={setActiveKw}
        htmlToDraft={htmlToDraft}
        setCompListCollapsed={setCompListCollapsed}
        compListCollapsed={compListCollapsed}
        setCheckedIndexData={setCheckedIndexData}
        checkedIndexData={checkedIndexData}
        setCheckedHeadingsWithTags={setCheckedHeadingsWithTags}
        checkedHeadingsWithTags={checkedHeadingsWithTags}
        setShowBulkAddContentBtn={setShowBulkAddContentBtn}
        showBulkAddContentBtn={showBulkAddContentBtn}
        setCheckedCount={setCheckedCount}
        checkedCount={checkedCount}/>
    </Drawer>
  );
});
